// @flow
import React from "react";
import styled from "styled-components";
import { fetchJson } from "../../lib/Fetching";
import ScheduleItem from "./ScheduleItem";
import type { TestSchedule, Product as ProductType } from "../../lib/Types";

const ScheduleListContainer = styled.div`
  padding: 20px;
  padding-top: 0px;
`;
const Table = styled.table`
  width: 100%;
`;
const Tr = styled.tr`
  > td,
  th {
    padding: 5px;
    border-bottom: 1px dotted #ddd;
  }
`;

type Props = {
  product_id: number,
  onlyPick: boolean,
  pickSchedule: Function
};

type State = {
  loading: boolean,
  schedules: Array<TestSchedule>
};

export default class ScheduleList extends React.Component<Props, State> {
  state = {
    loading: true,
    schedules: []
  };

  componentDidMount() {
    this.findSchedules();
  }

  findSchedules = () => {
    const { product_id } = this.props;
    fetchJson("/products/api/products/product_with_schedules", {
      product_id
    }).then((product: ProductType) => {
      this.setState({
        schedules: product.schedules,
        loading: false
      });
    });
  };

  render() {
    const { loading, schedules } = this.state;
    const { updateScheduleCount, product_id, onlyPick, pickSchedule } = this.props;
    return (
      <ScheduleListContainer>
        {!loading && (
          <Table>
            <thead>
              <Tr>
                <th style={{ width: 150 }}>&nbsp;</th>
                <th>{I18n.t("suite")}</th>
                <th>{I18n.t("specification")}</th>
              </Tr>
            </thead>
            <tbody>
              {schedules.map((schedule, i) => (
                <ScheduleItem
                  key={i}
                  schedule={schedule}
                  onlyPick={onlyPick}
                  pickSchedule={pickSchedule}
                />
              ))}
            </tbody>
          </Table>
        )}
      </ScheduleListContainer>
    );
  }
}
